import axios from 'axios';
import store from '@/store';
import { Toast } from 'vant';
import { encrypt, decrypt } from './aes';

const service = axios.create({
  baseURL: 'https://gm.biglemon.cloud/api', // 直接指向后端服务地址和路由前缀
  // baseURL: 'http://localhost:3000/api', // 直接指向后端服务地址和路由前缀
  timeout: 20000,
});

// 不需要加密的接口白名单
const NO_ENCRYPT_URLS = [
  // 可以根据实际需要添加不需要加密的接口
  // '/some-public-api',
];

// 判断是否需要加密
function needEncrypt(url) {
  return !NO_ENCRYPT_URLS.some(item => url.includes(item));
}

service.interceptors.request.use(
  config => {
    // 在 POST 请求体中添加 authorization 并加密
    if (config.method === 'post' && config.data) {
      try {
        let dataToEncrypt = { ...config.data };
        
        // 添加 authorization 到请求体
        const authorization = store.state.qmUserToken;
        console.log('[请求拦截器] URL:', config.url, '| authorization:', authorization);
        if (authorization) {
          dataToEncrypt.authorization = authorization;
        }
        
        // 判断是否需要加密
        if (needEncrypt(config.url)) {
          console.log('[请求加密前] 接口:', config.url, '| 数据:', dataToEncrypt);
          // 加密整个请求体
          const encryptedData = encrypt(dataToEncrypt);
          
          // 将加密后的数据放在 encryptedData 字段中
          config.data = {
            encryptedData: encryptedData
          };
          
          console.log('[请求加密后] 接口:', config.url, '已加密');
        } else {
          // 不需要加密的接口，直接使用原始数据
          config.data = dataToEncrypt;
        }
      } catch (error) {
        console.error('[请求加密失败]:', error);
        Toast.fail('请求加密失败');
        return Promise.reject(error);
      }
    }

    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    // 对微信代理接口的响应直接透传
    if (response.config.url.includes('/wx-payment-proxy') || response.config.url.includes('/qrconnect')) {
      return response.data;
    }

    let res = response.data;
    console.log('[响应原始数据]:', res);

    // 解密响应数据
    try {
      // 检查响应是否有加密标记或加密数据
      if (res && res.encrypted && res.data) {
        // 判断 data 字段是字符串（需要解密）还是对象（已解密）
        if (typeof res.data === 'string') {
          // 解密 data 字段
          const decryptedData = decrypt(res.data, true);
          res.data = decryptedData;
          console.log('[响应解密] 接口:', response.config.url, '已解密');
        } else {
          // data 已经是对象，可能后端已经解密或没加密
          console.log('[响应数据] 接口:', response.config.url, 'data已是对象，无需解密');
        }
        
        // 返回 data 内部的数据（兼容后端返回格式）
        if (res.data && (res.data.status || res.data.success || res.data.code !== undefined)) {
          res = res.data;
        }
      } else if (res && typeof res === 'object' && res.encryptedData) {
        // 如果整个响应体是加密的
        const decryptedData = decrypt(res.encryptedData, true);
        res = decryptedData;
        console.log('[响应解密] 接口:', response.config.url, '已解密');
      }
    } catch (error) {
      console.error('[响应解密失败]:', error);
      // 解密失败不阻断流程，继续处理原始数据
    }

    // 对项目内其他接口保持原有逻辑
    if (res.success || res.message == 'ok' || res.status) {
      return res;
      // handle error
    } else {
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  error => {
    console.log('err' + error);
    return Promise.reject(error);
  }
);

export default service; 